var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgChevronLeftRound = function SvgChevronLeftRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.25,
    transform: "rotate(-180 20 20)",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url([name='clip0_4740_33250'])"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.367 10.818l1.11 1.11L16.403 20l8.072 8.073-1.109 1.109L14.185 20l9.182-9.182z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.367 10.818l1.11 1.11L16.403 20l8.072 8.073-1.109 1.109L14.185 20l9.182-9.182z",
    stroke: "currentColor"
  }))));
};
export default SvgChevronLeftRound;